import classNames from "classnames";
import React, { useContext, useEffect, useRef, useState } from "react";
import { RicosContext, RicosNodeContext } from "./../../ricos-context";
import { CollapsibleListData_InitialExpandedItems } from "./../../ricos-schema/legacy/wix/rich_content/v1";
import { anchorScroll } from "./../../wix-rich-content-common";
import ExpandCollapseButton from "../components/ExpandCollapseButton";
import collapsibleListItemStyles from "../statics/styles/collapsible-list-pair.rtlignore-scss";
import { CollapsibleListContext } from "./collapsibleListContext";
const CollapsibleListItem = ({ node, nodeIndex, RicosNodesRenderer }) => {
  const { parentNode } = useContext(RicosNodeContext);
  const { expandedItemId, setExpandedItemId } = useContext(CollapsibleListContext);
  const containerRef = useRef(null);
  const { initialExpandedItems, expandOnlyOne } = parentNode?.collapsibleListData || {};
  const [isExpanded, setIsExpanded] = useState(
    CollapsibleListData_InitialExpandedItems.ALL === initialExpandedItems || nodeIndex === 0 && CollapsibleListData_InitialExpandedItems.FIRST === initialExpandedItems
  );
  const { t } = useContext(RicosContext);
  const styles = collapsibleListItemStyles;
  const toggleCollapsibleListBody = () => {
    setIsExpanded((prev) => !prev);
    setExpandedItemId(node.id);
    containerRef.current && anchorScroll(containerRef.current);
  };
  useEffect(() => {
    if (expandOnlyOne && expandedItemId && expandedItemId !== node.id) {
      setIsExpanded(false);
    }
  }, [expandedItemId]);
  const allChildrenList = node.nodes ?? [];
  const firstChildList = node.nodes?.[0] ? [node.nodes[0]] : [];
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.itemContainer, styles.itemContainerViewer),
      ref: containerRef
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.expandIcon }, /* @__PURE__ */ React.createElement(
      ExpandCollapseButton,
      {
        isExpanded,
        onClick: toggleCollapsibleListBody,
        ariaLabel: isExpanded ? t("CollapsibleListPlugin_ExpandButton_AriaLabel") : t("CollapsibleListPlugin_CollapseButton_AriaLabel")
      }
    )),
    /* @__PURE__ */ React.createElement("div", { className: styles.item }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: isExpanded ? allChildrenList : firstChildList }))
  ));
};
const CollapsibleListItemRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(CollapsibleListItem, { key: node.id, node, ...props });
};
var collapsibleListItem_default = CollapsibleListItemRenderer;
export {
  collapsibleListItem_default as default
};
//# sourceMappingURL=collapsibleListItem.js.map

import "@wix/ricos/css/plugin-collapsible-list-viewer.global.css";